/* eslint-disable import/prefer-default-export, no-shadow */
export const ABN_MIN_LENGTH = 11;
export const ACN_MIN_LENGTH = 9;
